/***********************************************************************
 This class represents the data model of a SCORM 1.2 SCO.
 ***********************************************************************/
import {Assert} from "common/Assert";

export const SCORE_MODEL_ID =  "cmi.core.score.raw";
export const LESSON_LOCATION_MODEL_ID =  "cmi.core.lesson_location";
export const LESSON_STATUS_MODEL_ID =  "cmi.core.lesson_status";

export function ScoData() {

    const EntryMap = new Map([
            ["lesson_id", 0],
            ["cmi.core.lesson_location", 1],
            ["cmi.core.lesson_status", 2],
            ["cmi.core.lesson_mode", 3],
            ["cmi.core.entry", 4],
            ["cmi.core.score.raw", 5],
            ["cmi.suspend_data", 6]
        ]),
        LessonModeMap = new Map( [
            ["interactive", "i"],
            ["show", "s"],
            ["film", "f"]
        ]),
        LessonStatusMap = new Map( [
            ["passed", "p"],
            ["completed", "c"],
            ["failed" , "f"],
            ["incomplete", "i"],
            ["browsed", "b"],
            ["not attempted", "n"]
        ]);

    let scoDataArray = initializeArray( EntryMap.size );

    function initializeArray( size ) {

        let initArray = [],
            i;

        for (i = 0; i < size; i++) {
            initArray.push("");
        }

        return initArray;
    }

    /**
     * Finds the first key-name in a map matching to a given value.
     */
    function getKeyByValue( objMap, sValue) {

        Assert.checkArgument( objMap, "objMap is undefined." );
        let result = "";
        objMap.forEach( (value, key ) => {
            if (value === sValue) {
                result = key;
            }
        });

        return result;
    }

    function getValue( dataModelId ) {

        Assert.checkArgument( dataModelId, "dataModelId is undefined." );

        if ( !EntryMap.has(  dataModelId  ) ) {
            return "";
        }

        const entryIndex = EntryMap.get(  dataModelId  );
        let value = scoDataArray[entryIndex],
            key;

        switch ( dataModelId ) {

            case "cmi.core.lesson_mode":
                key = getKeyByValue( LessonModeMap, value );
                if (key.length > 0) {
                    value = key;
                }
                break;

            case "cmi.core.lesson_status":
                key = getKeyByValue( LessonStatusMap, value );
                if (key.length > 0) {
                    value = key;
                }
                break;
        }

        return value;
    }

    // revealing public api
    return {

        getScoreModelId: () => SCORE_MODEL_ID,
        getLessonLocationModelId: () => LESSON_LOCATION_MODEL_ID,
        getLessonStatusModelId: () => LESSON_STATUS_MODEL_ID,

        getId: () => { return getValue("lesson_id") },

        setValue: function( dataModelId, value ) {

            Assert.checkArgument( dataModelId, "dataModelId is undefined." );

            if (value === "undefined") {
                return false;
            }

            if ( !EntryMap.has(dataModelId) ) {
                return false;
            }

            const nEntryIndex = EntryMap.get( dataModelId );
            let shortValue = value;

            switch (dataModelId) {

                case "cmi.core.lesson_mode" :
                    if( !LessonModeMap.has(value) ) {
                        return false;
                    }

                    shortValue = LessonModeMap.get( value );
                    break;

                case "cmi.core.lesson_status" :
                    if( !LessonStatusMap.has( value ) ) {
                        return false;
                    }

                    shortValue = LessonStatusMap.get( value );
                    break;
            }

            scoDataArray[nEntryIndex] = shortValue;

            return true;
        },

        getValue: getValue,

        isCompleted: function() {
            const scoLessonStatus = getValue("cmi.core.lesson_status");
            return scoLessonStatus === "passed" || scoLessonStatus === "p" || scoLessonStatus === "completed" || scoLessonStatus === "c";
        },

        isIncomplete: function() {
            return !this.isCompleted();
        },

        isFailed: function() {
            const scoLessonStatus = getValue("cmi.core.lesson_status");
            return scoLessonStatus === "failed" || scoLessonStatus === "f";
        },

        isPassed: function() {
            const scoLessonStatus = getValue("cmi.core.lesson_status");
            return scoLessonStatus === "passed" || scoLessonStatus === "p";
        },

        /**
         * exports all sco-values to a string.
         */
        exportToString: function ( customDelimiter ) {

            const delimiter = customDelimiter || "$";
            let result = "";

            scoDataArray.forEach( (scoData) => {

                if (result.length > 0) {
                    result += delimiter;
                }

                result += scoData;
            });

            return result;
        },

        /**
         * imports sco-values from a given string.
         */
        importFromString: function( dataAsString, delimiter) {

            if (dataAsString.length <= 0) {
                return false;
            }

            if (delimiter.length === 0) {
                delimiter = "$";
            }

            scoDataArray = dataAsString.split( delimiter );
            return scoDataArray.length === EntryMap.size;
        }
  };
}
